module.exports = __webpack_public_path__ + "static/media/imagem_fundo.e3825afa.png";